import ReavaliacaoDetalhe from '@/views/pages/patrimonio/reavaliacao/visualizacao/ReavaliacaoDetalhe.vue'
import ReavaliacaoListagem from '@/views/pages/patrimonio/reavaliacao/listagem/ReavaliacaoListagem.vue'

export default [
    {
        path: '/reavaliacao/todas',
        name: 'ReavaliacaoListagem',
        component: ReavaliacaoListagem,
        meta: {
            menu: {
                title: 'Reavaliações',
                icon: 'fas fa-folder',
            },
            page: {
                title: 'Reavaliações',
                subtitle: 'Lista geral das reavaliações'
            },
            requiresAuth: true,
            authorities: ['Patrimonio.Normal', 'Patrimonio.Consulta']
        }
    },
    {
        path: '/reavaliacao/:reavaliacaoId/visualizar',
        name: 'ReavaliacaoDetalhe',
        component: ReavaliacaoDetalhe,
        meta: {
            page: {
                title: 'Visualizar Reavaliação'
            },
            requiresAuth: true,
            authorities: ['Patrimonio.Normal', 'Patrimonio.Consulta']
        },
    }
]
